export default __webpack_public_path__ + "static/media/jansport.aca538ce.jpg";